// theme/components/drawer.js
export default {
    baseStyle: {
        header: {
            paddingTop: 1,
            paddingRight: [4, 4, 8, 8],
            paddingBottom: 1,
            paddingLeft: [4, 4, 8, 8],
            boxShadow: 'base'
        },
        body: {
            padding: [4, 4, 6, 6]
        },
        footer: {
            paddingTop: 6,
            paddingRight: [4, 4, 6, 6],
            paddingBottom: 11,
            paddingLeft: [4, 4, 6, 6]
        }
    },
    variants: {
        filterDrawer: {
            header: {
                pt: '20px',
                pb: '20px',
                pr: [4, 4, 8, 8],
                pl: [4, 4, 8, 8],
                boxShadow: 'none',
                borderBottom: '1px solid',
                borderColor: ' gray.50'
            },
            body: {
                padding: 0
            }
        },
        menuDrawer: {
            body: {
                padding: '0 0 140px 0'
            }
        }
    }
}
